/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { JobLog } from '../../models/job-log';

export interface GetLogsGrabber$Params {}

export function getLogsGrabber(
   http: HttpClient,
   rootUrl: string,
   params?: GetLogsGrabber$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Array<JobLog>>> {
   const rb = new RequestBuilder(rootUrl, getLogsGrabber.PATH, 'get');
   if (params) {
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Array<JobLog>>;
      })
   );
}

getLogsGrabber.PATH = '/api/weather/log/grab';
